'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventSectorRoutes = [
  {
    path: 'sectors',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.sector.list',
        props: true,
        component: () => import('../views/SectorListView.vue'),
      },
      // {
      //   path: ':sectorId',
      //   component: EmptyRouterView,
      //   props: true,
      //   children: [
      //     {
      //       path: '',
      //       name: 'event.sector.detail',
      //       component: () => import('../views/SectorDetailView.vue'),
      //     },
      //   ],
      // },
    ],
  },
];

export const eventManageSectorRoutes = [
  {
    path: 'sectors',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.manage.sector.list',
        props: true,
        component: () => import('../views/ManageSectorListView.vue'),
      },
      {
        path: 'add',
        name: 'event.manage.sector.add',
        props: true,
        component: () => import('../views/ManageSectorAddView.vue'),
      },
      {
        path: ':sectorId',
        component: EmptyRouterView,
        props: true,
        children: [
          {
            path: '',
            name: 'event.manage.sector.detail',
            props: true,
            component: () => import('../views/ManageSectorDetailView.vue'),
          },
          {
            path: 'edit',
            name: 'event.manage.sector.edit',
            props: true,
            component: () => import('../views/ManageSectorEditView.vue'),
          },
        ],
      },
    ],
  },
];
